import React, { useState, useEffect } from 'react';
import { useTickContext } from "../../contexts/TickContext";
import {useStateUpdatePermission} from "../../contexts/StateUpdateContext";
import {useQuoteContext} from "../../contexts/QuoteContext";

const ChangePercent = React.memo(({ trackedStock, changePercColor,setChangePercColor, onPriceDifferenceChange, contextName  }) => {
    const [PnLPercent, setPnLPercent] = useState(null);
    const { canUpdateState } = useStateUpdatePermission(); // Access the permission state
    const tickContext = useTickContext();
    const quoteContext = useQuoteContext();

    const contextData = (() => {
        switch (contextName) {
            case 'TickContext':
                return tickContext;
            case 'QuoteContext':
                return quoteContext;
            default:
                throw new Error(`Unknown context: ${contextName}`);
        }
    })();
    const tick = contextData.tick;

    // Fetch and calculate price difference
    useEffect(() => {
        if (canUpdateState) {
            if (tick.lastTradedPrice && trackedStock.avgBuyPrice) {
                const percentageDifference = ((tick.lastTradedPrice - trackedStock.avgBuyPrice) / trackedStock.avgBuyPrice) * 100;
                if (canUpdateState) {
                    setPnLPercent(percentageDifference.toFixed(2));
                } // Limit to 2 decimal places

                onPriceDifferenceChange(percentageDifference);  // Pass the value to the parent component

                // Determine color based on price difference

                if (tick.lastTradedPrice >= trackedStock.avgBuyPrice) {
                    setChangePercColor('#33A533'); // Set green for upward trend
                    /*setLastPriceColor('#33A533'); // Set green for last-traded-price*/
                } else {
                    setChangePercColor('#FF6666'); // Set red for downward trend
                    /*setLastPriceColor('#FF6666'); // Set red for last-traded-price*/
                }
            }
        }
    }, [tick.lastTradedPrice]);

    return (
        <div className="pnl-perc-st" style={{ color: changePercColor }}>
            <span>
    {PnLPercent !== null
        ? (PnLPercent < 0
            ? <span className="negative" >-</span>
            : null)
        : null} {/* Conditionally display the negative sign */}
                {PnLPercent !== null ? `${Math.abs(PnLPercent)}%` : '0.00%'}
            </span>
        </div>
    );
});

export default ChangePercent;
